import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface ReasonsErrorProps {
  content: string;
}

export const ReasonsError: React.FC<ReasonsErrorProps> = ({ content }) => (
  <div className="flex items-center gap-2 mt-2 text-red-500 text-sm">
    <ErrorOutlineIcon sx={{ fontSize: 16 }} />
    <span>{content}</span>
  </div>
);
